/**
 * SkipLink
 *
 * Skip to main content link for keyboard users.
 * Visible only when focused, allows skipping navigation.
 */

import React from 'react';

export interface SkipLinkProps {
  /** Target element ID to skip to */
  targetId?: string;
  /** Link text */
  text?: string;
}

export const SkipLink: React.FC<SkipLinkProps> = ({
  targetId = 'main-content',
  text = 'Skip to main content',
}) => {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const target = document.getElementById(targetId);
    if (target) {
      target.focus();
      target.scrollIntoView();
    }
  };

  return (
    <a
      href={`#${targetId}`}
      onClick={handleClick}
      className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4
                 focus:z-50 focus:px-4 focus:py-2 focus:bg-theme-accent focus:text-white
                 focus:rounded-lg focus:shadow-lg focus:outline-none
                 focus:ring-2 focus:ring-theme-accent focus:ring-offset-2"
      data-testid="skip-link"
    >
      {text}
    </a>
  );
};

export default SkipLink;
